<template>
  <div class="container">
    <h2 class="pt-5 mb-5">Create account</h2>
    <form method="post" name="test" style="margin: 0 auto; max-width: 500px;" @submit.prevent="onSubmit()" :data-vv-scope="formScope">

      <base-text-area name="companiesCountries" label="To which companies or countries do you need access?"
                      v-model="registration.companiesCountries"
                      :inline="false" height="200px"
                      v-validate="'required'"
                      :err="errors.collect('companiesCountries', formScope)"></base-text-area>

      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button radius="bl" component-class="blue" @click.native="previous" type="button">
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
          <base-button radius="br" component-class="green filled" type="submit">
            Next <i class="fas fa-arrow-right ml-3"></i>
          </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  import BaseTextArea from '@/components/inputs/text/BaseTextArea';
  import BaseButton from '@/components/inputs/button/BaseButton';

  export default {
    name: 'AccountCompanyData',
    mounted () {

    },
    methods: {
      onSubmit() {
        this.$validator.validateAll(this.formScope).then(result => {
          if (result) {
            this.$snotify.success('Validated, but no next step implemented.');
          }
        });
      },
      previous() {
        this.$router.go(-1);
      }
    },
    data() {
      return {
        formScope: 'companies-countries'
      };
    },
    computed: {
      registration: {
        get () {
          return this.$store.getters['registration/data'];
        },
        set (value) {
          this.$store.commit('registration/data', value);
        }
      }
    },
    components: {
      BaseTextArea, BaseButton

    }
  };

</script>
